export default [
  {
    path: '/apps/condicao-pagamento/list',
    name: 'apps-condicao-pagamento-list',
    component: () => import('@/views/cadastros-gerais/condicao-pagamento/list/Index.vue'),
    meta: {
      pageTitle: 'Condição Pagamento',
      resource: 'AdminHanes',
    },
  },
  // {
  //     path: '/apps/condicao-pagamento/edit/:id',
  //     name: 'apps-condicao-pagamento-edit',
  //     component: () => import('@/views/cadastros-gerais/condicao-pagamento/condicao-pagamento-edit/GrupoEstoqueEdit.vue'),
  //     meta: {
  //         pageTitle: 'Editar Familia Comercial',
  //         resource: 'AdminHanes',
  //     },
  // },
];
